import React from 'react';

const LoadingIcon = () => {
  return (
    <div className="loading-spinner">
      <div className="spinner"></div>
    </div>
  );
};

export default LoadingIcon;
